<div class="flex items-center border-b border-gray-200 py-2 pl-4">
  <h3 class="text-base font-semibold">{{ data.title }}</h3>
  @if (!dialogRef.disableClose) {
  <button
    type="button"
    class="ml-auto mr-2 border-0 bg-transparent p-2 transition-colors hover:text-primary-green"
    (click)="onClose()"
  >
    <span class="sr-only" i18n>Schliessen</span>
    <!-- For Safari we have to set the width and height of the SVG explicitly -->
    <pax-icon name="x" containerClass="h-5 w-5"></pax-icon>
  </button>
  }
</div>
<div class="relative overflow-auto p-4 pt-2">
  <!-- For basic info dialogs we can just pass a (markdown) string  -->
  @if (data.contentAsMarkdown) {
  <pax-markdown>{{ data.contentAsMarkdown }}</pax-markdown>
  }
  <!-- For advanced usages we can pass a component template -->
  <ng-container
    *ngTemplateOutlet="data?.contentTemplate || null; context: { $implicit: data }"
  ></ng-container>
</div>
@if (data.showCloseButton) {
<div class="flex justify-end border-t border-gray-200 p-3">
  @if (!dialogRef.disableClose) {
  <button
    type="button"
    paxButton
    variant="primary"
    size="sm"
    (click)="onClose()"
    i18n
    >Schliessen</button
  >
  }
</div>
}
